import React from "react";
import { Switch, Route } from "react-router-dom";
import Error404 from "../Error404";

import ProductKnowledgeSourceRoute from "./product/knowledge-source/routes";
import ProductKnowledgeChunkRoute from "./product/knowledge-chunk/routes";

export default ({ match }) => {
  return (
    <Switch>
      <Route
        path={`${match.path}/product/knowledge-source`}
        component={ProductKnowledgeSourceRoute}
      />
      <Route
        path={`${match.path}/product/knowledge-chunk`}
        component={ProductKnowledgeChunkRoute}
      />
      <Route component={Error404} />
    </Switch>
  );
};
